<template>
  <div :class="['$attrs.class', {'tw-animate-pulse': processingRemove}]">
    <div class="tw-overflow-hidden tw-py-8 tw-px-4 tw-block tw-group tw-flex">
      <div class="tw-w-48 tw-mr-8 tw-flex-grow-0  tw-hidden lg:tw-block" v-if="props.size == 'full'">
        <img 
          :alt="product.name+' image'"
          class="tw-w-full"
          :src="productImage">
      </div>
      <div :class="['tw-flex-1 tw-relative tw-flex', {'tw-pb-16': props.size == 'full'}]">
        <div class="tw-w-full tw-flex">
          <div class="tw-mr-2">
            <h3 class="tw-font-black">
              <span class="tw-lowercase" v-if="product.quantity > 1">{{product.quantity}}x</span>
              {{product.name}}
            </h3>
            <div>
            <template v-if="product.choices && product.choices.length > 0">
              <template
                v-for="(choice, index) in product.choices"
                :key="'choice-' + product.id.toString() + '-' + choice.id"
                >
                <template v-if="choice.quantity > 1">{{choice.quantity}}x </template>{{choice.name}}<template v-if="index < product.choices.length -1">, </template>
              </template>
            </template>
            <template v-else>
              {{product.description}}
            </template>
            </div>
          </div>
          <div class="tw-ml-auto">
            <div class=" tw-text-center tw-mb-4 tw-relative">
              <template v-if="updatingQuantity">
                <span class="tw-absolute tw-right-10 tw-top--2 tw-z-10 tw-inline-block fa fa-spinner tw-animate-spin tw-text-4xl"></span>
              </template>
              <div :class="['tw-font-black tw-transition-all tw-duration-300', {'tw-opacity-0': updatingQuantity}]">
                ${{product.totalcost.toLocaleString("en-US", {minimumFractionDigits: 2})}}
              </div>
            </div>
            <div class="tw-text-right tw-flex tw-justify-end">
              <template v-if="props.size == 'small'">
                <template v-if="(product.getMetaDataByKey('modifiable') != false)">
                  <template v-if="product.isCatering()">
                    <component
                      :is="processingRemove ? 'span' : 'router-link'"
                      :to="{ name: 'edit-product', params: {id: product.productId, bpid: product.id }}"
                      :class="['tw-flex tw-items-center tw-inline-block tw-rounded-lg tw-text-xs tw-border tw-border-black tw-uppercase tw-font-bold tw-px-2 tw-py-1 tw-mr-2 tw-transition-all tw-duration-200', {'hover:tw-text-orange-medium hover:tw-border-orange-medium': !processingRemove}, {'hover:tw-text-black tw-opacity-40 tw-cursor-default': processingRemove}]" 
                      >
                      <span class="fa fa-pencil-alt tw-text-sm tw-inline-block tw-mr-1"></span>Edit
                    </component>
                  </template>
                  <template v-else>
                    <a 
                      :href="'/order/customize/'+product.id+'/?basket_product=true&oc_redirect=true'"
                      :class="['tw-flex tw-items-center tw-inline-block tw-rounded-lg tw-text-xs tw-border tw-border-black tw-uppercase tw-font-bold tw-px-2 tw-py-1 tw-mr-2 tw-transition-all tw-duration-200', {'hover:tw-text-orange-medium hover:tw-border-orange-medium': !processingRemove}, {'hover:tw-text-black tw-opacity-40 tw-cursor-default': processingRemove}]" 
                      :disabled="processingRemove"
                      >
                      <span class="fa fa-pencil-alt tw-text-sm tw-inline-block tw-mr-1"></span>Edit
                    </a>
                  </template>
                </template>
                <TwButton 
                  cssClass="tw-bg-transparent tw-text-2xl tw-text-black hover:tw-text-orange-medium tw-uppercase tw-font-bold  tw-transition-all tw-duration-200 tw-px-2" 
                  @emit-click="removeProduct()" 
                  :isLoading="processingRemove"
                  :isDisabled="false" 
                  :iconClass="'fa fa-trash'"
                  buttonText=""/>
              </template>
            </div>
          </div>
          <div 
            class="tw-absolute tw-bottom-0 tw-w-full tw-flex tw-justify-between"
            v-if="props.size == 'full'">
            <template v-if="product.getMetaDataByKey('modifiable') != false">
              <template v-if="product.isCatering()">
                <router-link
                  :to="{ name: 'edit-product', params: {id: product.productId, bpid: product.id }}"
                  class="tw-flex tw-items-center tw-inline-block tw-rounded-lg tw-text-lg hover:tw-text-orange-medium tw-border tw-border-black hover:tw-border-orange-medium tw-uppercase tw-font-bold tw-px-4 tw-py-2 tw-transition-all tw-duration-200" 
                  >
                  <span class="fa fa-pencil-alt tw-text-xl tw-inline-block tw-mr-2"></span>Edit
                </router-link>
              </template>
              <template v-else>
                <a :href="'/order/customize/'+product.id+'/?basket_product=true'"
                    class="tw-flex tw-items-center tw-inline-block tw-rounded-lg tw-text-lg hover:tw-text-orange-medium tw-border tw-border-black hover:tw-border-orange-medium tw-uppercase tw-font-bold tw-px-4 tw-py-2 tw-transition-all tw-duration-200" 
                    >
                    <span class="fa fa-pencil-alt tw-text-xl tw-inline-block tw-mr-2"></span>Edit
                  </a>
              </template>
            </template>
            <template v-else>
              <div></div>
            </template>
            <div class="tw-flex">
              <TwButton 
                  cssClass="tw-bg-transparent tw-text-3xl tw-text-black hover:tw-text-orange-medium tw-uppercase tw-font-bold  tw-transition-all tw-duration-200 tw-px-2 tw-mr-4" 
                  @emit-click="removeProduct()" 
                  :isLoading="processingRemove"
                  :isDisabled="false" 
                  :iconClass="'fa fa-trash'"
                  buttonText=""/>

              <div>
                <div class="tw-flex tw-items-center tw-relative tw-w-32">
                  <input 
                  v-model="quantity"
                  min="1"
                  increment="1"
                  :disabled="updatingQuantity"
                  class="tw-w-full tw-text-xl tw-text-center tw-px-8 tw-py-3 tw-border focus:tw-outline-none tw-border-gray-400 focus:tw-border-orange-medium focus:tw-ring-0 tw-rounded-full"
                  type="number">
                  <button
                    @click="decrementQuantity"
                    :disabled="updatingQuantity"
                    class="tw-px-4 tw-text-xl hover:tw-text-orange-medium tw-transition-all tw-font-black tw-text-black tw-absolute tw-left-0">
                    &mdash;
                  </button>
                  <button
                    @click="incrementQuantity"
                    :disabled="updatingQuantity"
                    class="tw-px-4 tw-text-xl hover:tw-text-orange-medium tw-transition-all tw-font-black tw-text-black tw-absolute tw-right-0 ">
                    +
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed, watch } from 'vue'
  import { useDebounceFn } from '@vueuse/core'
  import type BasketProduct from '../../classes/BasketProduct';

  import TwButton from '../../components/TwButton.vue';

  const props = defineProps<{ product: BasketProduct, size: String }>();
  
  const emit = defineEmits(['emitRemoveProduct', 'emitUpdateProduct'])

  const processingRemove = ref(false);
  const updateRequired = ref(false);
  const updatingQuantity = ref(false);
  const originalQuantity = ref(1);
  const quantity = ref(1);

  const productImage = computed(() => {
    if (props.product != null && props.product.images) {
      let img = props.product.getImageByKey("product_web_category")

      if (img) {
        return img.url;
      } else {
        return 'https://mypiada-assets.s3.amazonaws.com/static_assets/scooter-placeholder.jpg';
      }
    } else {
      return '';
    }
  })

  onMounted(() => {
    originalQuantity.value = props.product.quantity;
    quantity.value = props.product.quantity;
  })

  watch(() => quantity.value, (qty, prevQty) => {
    if (qty < 1) {
      quantity.value = 1;
    }
    debouncedUpdateQuantity();
  })

  watch(() => props.product.quantity, (qty, prevQty) => { 
    if(qty != prevQty) {
      originalQuantity.value = props.product.quantity;
      updateRequired.value = false;
      updatingQuantity.value = false;
    }
  })

  const debouncedUpdateQuantity = useDebounceFn(() => {
    if (quantity.value != originalQuantity.value) {
      updatingQuantity.value = true;
      emit('emitUpdateProduct', props.product, props.product.id, quantity.value )
    }
  }, 500)

  const removeProduct = () => {
    processingRemove.value = true
    emit('emitRemoveProduct', props.product.id)
  }

  const decrementQuantity = () => {
    quantity.value = Math.max(quantity.value -= 1, 1);
    
  };

  const incrementQuantity = () => {
    quantity.value = Math.min(quantity.value += 1, 99);
  };

  const updateQuantity = () => {
    updatingQuantity.value = true;
    emit('emitUpdateProduct', props.product, props.product.id, quantity.value )
  }

</script>


<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
